import { Drawer as MuiDrawer, DrawerProps, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { X } from 'react-feather';
import { Button } from './forms/Button';

const useDrawerClasses = makeStyles({
    root: {
        borderRadius: '25px 0 0 0',
    },
    button: {
        position: 'absolute',
        right: 15,
        top: 15,
    },
});

/**
 * Extension of the material-ui drawer with a close button and style changes.
 * For the drawer to work without glitches, a width must be provided through classes or styles.
 *
 * @param props drawer properties, some properties cannot be overridden
 */
export const Drawer = (props: DrawerProps) => {
    const classes = useDrawerClasses();

    return (
        <MuiDrawer {...props} classes={{ ...props.classes, paper: clsx(classes.root, props.classes?.paper) }}>
            <Button className={classes.button} icon='rounded' onClick={() => props.onClose?.({}, 'backdropClick')}>
                <X />
            </Button>
            {props.children}
        </MuiDrawer>
    );
};
